import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const EnergyLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        fill='#e8e337'
        height='40px'
        viewBox='0 0 80 40'
        width='80px'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='m51.328 30.196 4.526 8.014h-6.345l-4.08-7.271H40.31l-1.446 7.271h-6.048l5.196-25.971h10.574c6.454 0 10.164 2.967 10.164 8.05 0 5.082-2.781 8.459-7.42 9.905l-.002.002Zm1.335-9.348c0-2.522-1.781-3.711-4.859-3.711h-4.749l-1.819 9.016h5.12c3.969 0 6.307-1.855 6.307-5.305ZM79.046 24.862h5.491l-2.151 10.684c-2.635 2.004-6.195 3.154-9.942 3.154-7.866 0-12.836-4.563-12.836-11.278 0-8.866 6.492-15.583 16.323-15.583 4.972 0 8.606 1.596 10.834 4.527l-4.303 3.487c-1.745-2.078-3.896-2.894-6.791-2.894-6.084 0-9.981 4.376-9.981 10.091 0 3.896 2.598 6.531 7.531 6.531 1.522 0 2.931-.297 4.303-.927l1.522-7.79v-.002ZM26.683 26.003 15.81 7.115 8 42.75l9.824-18.619L28.942 44 36.98 4 26.683 26.003Z'
            fill='fill'
            transform='matrix(1.016 0 0 1 -8.1255 -4)'
        />
    </SvgElement>
);
